import React from 'react';
import { ToastContainer } from 'react-toastify';

const Toastr = () => {
    return (<>
        <ToastContainer
            position="top-right"
            autoClose={5000}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            hideProgressBar
        />
    </>)
}

export default Toastr

